/**
 * Shared `<system-prompt-reminder>` fragments appended to Operator tool descriptions.
 * Keep these in one place so Braze* wrappers and global tools stay consistent.
 */

/** Disabled options are omitted from scraped selects and listed on data-unavailable-options. */
export const selectEnabledOptionReminder =
  "<system-prompt-reminder>Only select an enabled option from the target <select>. Never pass the value of a disabled option, including values listed in data-unavailable-options.</system-prompt-reminder>";

/** Same rule for menu actions that scrape as a select of actions. */
export const selectEnabledActionReminder =
  "<system-prompt-reminder>Only click an enabled action from the target <select>. Never pass the value of a disabled option, including values listed in data-unavailable-options.</system-prompt-reminder>";

/** Checkbox groups list unavailable labels on data-unavailable-options. */
export const checkboxGroupEnabledReminder =
  "<system-prompt-reminder>Only toggle an enabled checkbox from the target fieldset. Never pass the label of a disabled or readonly checkbox, including labels listed in data-unavailable-options.</system-prompt-reminder>";

/** Radio groups may include disabled/readonly options. */
export const radioEnabledOptionReminder =
  "<system-prompt-reminder>Only select an enabled option from the target <select>. Never pass the value of a disabled or readonly option, including values listed in data-unavailable-options.</system-prompt-reminder>";

/**
 * Tools that must run alone (page scrape, tab switch, progress tracker). Append when the
 * tool description also needs other reminders.
 */
export const noParallelToolCallsReminder =
  "<system-prompt-reminder>IMPORTANT: This tool must NOT be called in parallel with other tool calls. Always call this tool on its own, and wait for the result before making other tool calls.</system-prompt-reminder>";
